module.exports = __webpack_public_path__ + "79c388efbf680be038476f0d265a392c.jpg";